import React from "react"
import PropTypes from "prop-types"
import { TextField, TextFieldProps } from "@material-ui/core"
import { useField } from "formik"

const TextInput = ({ name, ...rest }) => {
  const [field, meta] = useField(name)

  return (
    <TextField
      margin="normal"
      {...rest}
      {...field}
      variant="filled"
      error={meta.touched && meta.error ? true : false}
      helperText={(meta.touched && meta.error) || ""}
    />
  )
}

TextInput.propTypes = {
  name: PropTypes.string,
}

export { TextInput }
